import { render, staticRenderFns } from "./Configurations.vue?vue&type=template&id=a9cb657e&scoped=true&"
import script from "./Configurations.vue?vue&type=script&lang=js&"
export * from "./Configurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cb657e",
  null
  
)

export default component.exports